export enum BwicInventoriesTabs {
    Bwic = 1,
    Inventory = 2
}
